import SvgJsx from "../templateux/svg/svg-jsx"

export default function SortTab({
    sort
    ,set_sort
    ,dir
    ,set_dir
    ,e0
    ,e1
    ,e2
    ,round_left
    ,round_right
}) {
    return (<>
    <div
                                        
                                        className={`border flex items-center content-center cursor-pointer px-2 py-1 
                                                    border-gray-700 hover:border-gray-200 text-md
                                                    ${sort == e1
                                                        ? "bg-gray-700 font-bold" 
                                                        : ""} 
                                                    
                                                    ${round_left
                                                            ? " rounded-l " 
                                                            : " "} 
                                                            
                                                    ${round_right
                                                            ? " rounded-r " 
                                                            : " "} 
                                                
                                                `}
                                        onClick={() => {
                                            set_sort(e1)
                                            if (e2 == 1) set_dir(dir=="down" ? "up" : "down")
                                        }}
                                    >
                                        <div className="flex-0">
                                            {e0}
                                        </div>
                                        {sort == e1 && e2 == 1 &&
                                        <div className="flex-0 ml-1">
                                        <SvgJsx 
                                            type='fill' 
                                            icon={dir == "up" ?  `arrow-narrow-down-sm` : `arrow-narrow-up-sm`} 
                                            className=' w-4 h-4 flex-0 my-auto' 
                                            title={dir == "up" ? `down` : `up`} 
                                        />
                                        </div>
                                        }
                                    </div>
    </>)
}